var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.getHardCompetences.length)?_c('CompetencesEmpty',{attrs:{"competences-type":"hard"}}):_c('HardCompetences',{attrs:{"items":_vm.getHardCompetences,"variants":_vm.getCompetenceKnowledge}})
}
var staticRenderFns = []

export { render, staticRenderFns }